import axios from "axios";
import Config from "../../../config";

const v2_actionDeletarCustomTab = (tabId) => {
    return axios({
        method: "put",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/crm/custom-tabs/${tabId}/deletar`
    });
};

export default v2_actionDeletarCustomTab;
